import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { googleLogout } from '@react-oauth/google';

import { useAssistantStore } from '@/shared/store/assistant.store';
import { useAuthStore } from '@/shared/store/auth.store';

import { GtwAuth } from '../generated/GtwAuth';
import { getApiConfig } from '../helpers/getApiConfig';

export const useLogout = () => {
  const apolloClient = useApolloClient();
  const authStore = useAuthStore();
  const assistantStore = useAssistantStore();
  const gtwAuth = new GtwAuth(getApiConfig(authStore.accessToken, { logout: async () => {} }));

  const logout = useCallback(async () => {
    await gtwAuth.authLogout({});

    googleLogout();
    localStorage.clear();
    assistantStore.clear();

    await apolloClient.resetStore();
    window.location.href = '/';
  }, []);

  return { logout };
};
